module.exports = __webpack_public_path__ + "static/imagem-01-equipamentos-34e32d6eddcfa39157c95b0f2c9b3265.jpg";